import { queryOptions } from "ui-common/query-options";
import { rpc } from "ui-common/services/rpc";

export const worldsQueryOptions = queryOptions({
  queryKey: ["worlds"],
  queryFn: () => rpc("worldsQuery", undefined),
});
